export const LOCAL_LOG_LEVELS = ["log", "info", "warn", "error", "debug", "trace"] as const;
export const LOCAL_LOG_LOOPBACK_HOSTS = new Set(["localhost", "127.0.0.1", "[::1]"]);
export const LOCAL_LOG_MAX_QUEUE = 200;
export const LOCAL_LOG_MAX_MESSAGE = 2000;
export const LOCAL_LOG_MAX_BATCH_BYTES = 48 * 1024;
export const LOCAL_LOG_MAX_BATCH_ENTRIES = 20;
export const LOCAL_LOG_FLUSH_MS = 500;
export const LOCAL_LOG_RETRY_MS = 2000;
export const LOCAL_LOG_TIMEOUT_MS = 5000;
export const LOCAL_LOG_SECRET_KEY =
  /authorization|cookie|password|secret|token|api[-_]?key|email|prompt|^(?:headers|body|payload|request|response|content)$/i;
export const LOCAL_LOG_BEARER = /Bearer\s+[^\s"',}]+/gi;
export const LOCAL_LOG_JWT = /\beyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+/g;
export const LOCAL_LOG_SECRET_ASSIGNMENT =
  /((?:authorization|cookie|password|secret|[\w-]*token|api[-_]?key)["']?\s*[:=]\s*)(?:"[^"\r\n]*"|'[^'\r\n]*'|[^\s,;}]+)/gi;
export const LOCAL_LOG_URL_QUERY = /(https?:\/\/[^\s?"'<>]+)\?[^\s"'<>]*/gi;
export const LOCAL_LOG_EMAIL = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;
